<!--
 * @Descripttion: 
 * @version: 
 * @Author: wanglikun
 * @Date: 2023-06-24 13:38:05
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-07-01 16:54:21
-->
<template>
  <div class="table-count">
    <span
      >{{ $lang('共') }}
      <span class="table-number">{{ props.total }}</span>
      {{ $lang('条') }}</span
    >
  </div>
</template>
<script lang="ts" setup>
  interface IProps {
    total: any
  }
  const props = defineProps<IProps>()
</script>
<style lang="less" scoped>
  .table-count {
    margin-bottom: 16px;
    margin-right: 20px;
    .table-number {
      color: @primary-color;
      font-weight: bold;
    }
  }
</style>
